var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 21,
    viewBox: "0 0 23 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#989AAE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v21h23V0H0zm1.348 1.394h16.261V4.18H1.348V1.394zm20.304 18.212H1.348V5.576h20.304v14.03zm0-15.425h-2.695V1.394h2.695V4.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8 11.407v5.159h7.006l1.313 2.11h.81l1.313-2.11h7.006v-5.159H2.8zm16.113 3.752H12.52l-.997 1.602-.997-1.602H4.135v-2.345h14.778v2.345z"
  }))));
}

export default __webpack_public_path__ + "./fonts/ad-account.253c86bcc9142f90e4c294d546ddeb22.svg";
export { SvgAdAccount as ReactComponent };